import { render, staticRenderFns } from "./myactivity.vue?vue&type=template&id=bf81c382&scoped=true&"
import script from "./myactivity.vue?vue&type=script&lang=js&"
export * from "./myactivity.vue?vue&type=script&lang=js&"
import style0 from "./myactivity.vue?vue&type=style&index=0&id=bf81c382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf81c382",
  null
  
)

export default component.exports